import React from 'react'
import {RouteRideList} from 'common/RouteRideList'
import {PinnedList} from '../PinnedList'
import {URLTabCard, TabCardItem} from 'common/styleguide/TabCard'
import _ from 'lodash'
import p from 'prop-types'

export class Tabs extends React.PureComponent {
  static propTypes = {
    currentUser: p.any.isRequired,
    recentTRoutes: p.any.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      cachedTRoutes: null
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.recentTRoutes !== prevProps.recentTRoutes) {
      // Blow out the local cache if this component somehow receives new results from loadable
      this.setState({cachedTRoutes: null})
    }
  }

  onTRouteResults = (search) => {
    if (search.params.keywords === '') {
      this.setState({cachedTRoutes: search})
    }
  }

  onDeleteResult = (record, callback) => {
    this.setState((state, props) => {
      const troutes = state.cachedTRoutes || props.recentTRoutes

      const newTRoutes = Object.assign({}, troutes, {results: _.reject(troutes.results, (r) => r === record), results_count: troutes.results_count - 1})
      return {
        cachedTRoutes: newTRoutes
      }
    }, callback)
  }

  render () {
    const {recentTRoutes, currentUser} = this.props
    const {cachedTRoutes} = this.state

    const troutes = cachedTRoutes || recentTRoutes

    return (
      <URLTabCard name='dashboardTab'>
        <TabCardItem id='routes_rides' title='Routes & Rides'>
          <RouteRideList
            owned
            user={currentUser}
            initialTRoutes={troutes}
            onResults={this.onTRouteResults}
            onDeleteResult={this.onDeleteResult} />
        </TabCardItem>
        <TabCardItem id='pinned' title='Pinned'>
          <PinnedList currentUser={currentUser} />
        </TabCardItem>
      </URLTabCard>
    )
  }
}
